import * as React from 'react'
import ExchangeRateConfiguration, {
  ExchangeRateConfigurationStateProps,
  ExchangeRateConfigurationOwnProps,
} from './exchangeRateConfiguration'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { withLoading } from '@/modules/shared/hocs/withLoading'
import { showMessage } from '@/modules/shared/stores/messageStore'
import {
  downloadExchangeRatesRequest,
  exchangeRateConfigKey,
  fetchExchangeRateConfiguration,
} from '@/modules/settings/services/configurationQueries'

const Wrapped = withLoading(
  ExchangeRateConfiguration as any,
) as unknown as React.ComponentType<any>

/**
 * Kursy walut bez slice'a `configuration`.
 *
 * Ekran pobiera je sam - z datą i źródłem wybranym w formularzu - więc `useQuery`
 * tylko obserwuje cache, a pobieraniem zajmuje się `fetchQuery`, tak jak wcześniej
 * thunk. Klucz jest per firma; data i źródło zostają parametrami zapytania,
 * bo slice też trzymał tylko ostatni wynik.
 */
const ExchangeRateConfigurationContainer: React.FC<
  ExchangeRateConfigurationOwnProps
> = (props) => {
  const queryClient = useQueryClient()
  const companyId = props.companyId

  const { data: configuration = null } = useQuery({
    queryKey: exchangeRateConfigKey(companyId),
    queryFn: () => fetchExchangeRateConfiguration(companyId, null, 0),
    enabled: false,
  })

  const getExchangeRateConfiguration = React.useCallback(
    (id: string, rateDate: any, source: number) =>
      queryClient.fetchQuery({
        queryKey: exchangeRateConfigKey(id),
        queryFn: () => fetchExchangeRateConfiguration(id, rateDate, source),
      }),
    [queryClient],
  )

  return (
    <Wrapped
      {...props}
      companyId={companyId}
      configuration={
        configuration as ExchangeRateConfigurationStateProps['configuration']
      }
      showMessage={showMessage}
      getExchangeRateConfiguration={getExchangeRateConfiguration}
      downloadExchangeRates={downloadExchangeRatesRequest}
    />
  )
}

export default ExchangeRateConfigurationContainer
